/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAModelBuilderInputConfigGrassCategoryQueryVariables = {||};
export type PGAModelBuilderInputConfigGrassCategoryQueryResponse = {|
  +grassCategories: ?$ReadOnlyArray<?{|
    +id: string,
    +categoryName: string,
  |}>,
  +pgaTourCourses: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
  |}>,
|};
export type PGAModelBuilderInputConfigGrassCategoryQuery = {|
  variables: PGAModelBuilderInputConfigGrassCategoryQueryVariables,
  response: PGAModelBuilderInputConfigGrassCategoryQueryResponse,
|};
*/


/*
query PGAModelBuilderInputConfigGrassCategoryQuery {
  grassCategories {
    id
    categoryName
  }
  pgaTourCourses {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PGATourGrassCategoryType",
    "kind": "LinkedField",
    "name": "grassCategories",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryName",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PGATourCourseType",
    "kind": "LinkedField",
    "name": "pgaTourCourses",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderInputConfigGrassCategoryQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PGAModelBuilderInputConfigGrassCategoryQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c1c0d2b2cf680f9e9755caaab89711ed",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderInputConfigGrassCategoryQuery",
    "operationKind": "query",
    "text": "query PGAModelBuilderInputConfigGrassCategoryQuery {\n  grassCategories {\n    id\n    categoryName\n  }\n  pgaTourCourses {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bd88e700014ca5f927142ecb0c22b8a4';

module.exports = node;
